import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGraphStats = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	height: "1em",
	width: "1em",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M.75,11.75h3.5a1.5,1.5,0,0,0,1.385-.923l2.6-6.115a.75.75,0,0,1,1.4.051l4.734,14.725a.75.75,0,0,0,1.4.051l2.595-6.866a1.5,1.5,0,0,1,1.385-.923h3.5",
		fill: "none",
		stroke: "var(--icon-color, currentColor)",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5
	})
});
export default SvgGraphStats;
